export const BLOCKCHAIN = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="56" height="56" rx="8" fill="#946CF3" fillOpacity="0.05" />
      <rect
        x="0.666477"
        y="0.666477"
        width="54.667"
        height="54.667"
        rx="7.33352"
        stroke="#946CF3"
        strokeOpacity="0.15"
        strokeWidth="1.33295"
      />
      <path
        d="M28.0001 28V35.7344M28.0001 28L34.875 24.1328M28.0001 28L21.125 24.1328M26.7743 20.955L22.3993 23.416C21.6122 23.8588 21.125 24.6917 21.125 25.5949V30.405C21.125 31.3082 21.6122 32.1412 22.3993 32.584L26.7743 35.0449C27.5354 35.473 28.4646 35.473 29.2257 35.0449L33.6007 32.584C34.3878 32.1412 34.875 31.3082 34.875 30.405V25.5949C34.875 24.6917 34.3878 23.8588 33.6007 23.416L29.2257 20.955C28.4646 20.527 27.5354 20.527 26.7743 20.955Z"
        stroke="#946CF3"
        strokeWidth="1.87"
        strokeLinejoin="round"
      />
    </svg>
  );
};
